export const checkPromoCode = async (coupon: string): Promise<Coupon> => {
    const response = await fetch('/wp-json/wr-cart/discount/check/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            coupon,
            checkout_mode: 'promo',
        }),
    })

    if (response.status === 200) {
        const couponResponse: CouponPromoResponse = await response.json()
        if (couponResponse.active && couponResponse.coupon.valid) {
            return {
                ...couponResponse.coupon,
                type: 'promo',
                code: couponResponse.code,
                email: couponResponse.email,
            }
        }
    }

    throw new Error(`Invalid coupon code: ${coupon}`)
}


export const checkCouponCode = async (coupon: string): Promise<Coupon> => {
    const response = await fetch('/wp-json/wr-cart/discount/check/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            coupon,
            checkout_mode: 'membership',
        }),
    })

    if (response.status === 200) {
        const couponResponse: CouponMembershipResponse = await response.json()
        if (!couponResponse.deleted && couponResponse.valid && (couponResponse.max_redemptions === 0 || couponResponse.times_redeemed < couponResponse.max_redemptions)) {
            return {
                ...couponResponse,
                code: coupon,
                type: 'membership',
            }
        }
    }

    throw new Error(`Invalid coupon code: ${coupon}`)
}
